// extracted by mini-css-extract-plugin
export default {"simpleHeaderWrapper":"styles_simpleHeaderWrapper__jxbp-"};